import { initNavbar } from './navbar.js';
import { initModulesSwitcher } from './modules-switcher.js';
import { initScreenshotViewer } from './screenshot-viewer.js';
import { initContactModal } from './contact-modal.js';
import { initFaqAccordion } from './faq-accordion.js';
import { initFormValidator } from './form-validator.js';

document.addEventListener('DOMContentLoaded', () => {
  initNavbar();
  initModulesSwitcher();
  initScreenshotViewer();
  initContactModal();
  initFaqAccordion();
  initFormValidator();
});
